import React, { useMemo } from 'react';
import { Stepper } from '@lomadee/design-system';

import CreateAccountContainer from '@plug/domains/auth/components/create-account-container';
import { useCreateOrganizationContext } from '@plug/contexts/CreateOrganizationContext';
import OrganizationRegistrationPasswordStep from './components/OrganizationRegistrationPassword';
import OrganizationRegistrationPersonalDataStep from './components/OrganizationRegistrationPersonalData';
import OrganizationRegistrationOrganizationDataStep from './components/OrganizationRegistrationOrganizationData';
import OrganizationRegistrationAddressDataStep from './components/OrganizationRegistrationAddressData';

import { StepperWrapper, MiniStepperWrapper } from './style';
import OrganizationRegistrationInviteTeammatesStep from './components/OrganizationRegistrationInviteTeammates';

const OrganizationSignUp: React.FC = () => {
  const { step } = useCreateOrganizationContext();

  const Component = useMemo(() => {
    switch (step) {
      case 'PASSWORD':
        return <OrganizationRegistrationPasswordStep />;
      case 'PERSONAL_DATA':
        return <OrganizationRegistrationPersonalDataStep />;
      case 'ORGANIZATION_DATA':
        return <OrganizationRegistrationOrganizationDataStep />;
      case 'ADDRESS_DATA':
        return <OrganizationRegistrationAddressDataStep />;
      case 'INVITE_TEAMMATES':
        return <OrganizationRegistrationInviteTeammatesStep />;

      default:
        return <h1>default</h1>;
    }
  }, [step]);

  const StepNumber = (function(): number {
    switch (step) {
      case 'PASSWORD':
        return 0;
      case 'PERSONAL_DATA':
        return 1;
      case 'ORGANIZATION_DATA':
        return 2;
      case 'ADDRESS_DATA':
        return 3;
      case 'INVITE_TEAMMATES':
        return 4;
    }
  })();

  return (
    <CreateAccountContainer type="admin">
      <StepperWrapper>
        <Stepper hierarchy="ghost" steps={5} currentStep={StepNumber} />
      </StepperWrapper>

      {Component}

      <MiniStepperWrapper>
        <Stepper mini steps={5} currentStep={StepNumber} />
      </MiniStepperWrapper>
    </CreateAccountContainer>
  );
};

export default OrganizationSignUp;
